module.exports = __webpack_public_path__ + "img/proyecto_12.5d8fd608.webp";